export interface VoucherCreateModel {
  brand: VoucherBrandEnum;
  source: string; // Až bude mít pokladna konkrétní URL, vyměňte za konkrétní URL pokladny   'Nová pokladna'
  sendEmailToOwner: boolean; // vždy true, pošle voucher na email zákazníka
  idVoucherPayment: string; // example "KARP/001/028"
  paymentVariable: string; // 
  voucherCurrency: CurrencyEnum;
  voucherPrice: number; // Price
  voucherVersion: VoucherSkinEnum;
  voucherOwner: VoucherOwnerModel;  // ten, kdo si kupuje poukaz
  voucherPDF: {
    note: string; // "Věnování sem je možné vypsat až 200 znaků maximálně"
  },
}

interface VoucherOwnerModel {
  ownerName: string;
  ownerSurname: string;
  ownerEmail: string;
  ownerPhone: string; // not number because of country code in format +421 
  ownerCustomerId: string; // null, nemáme
}

export enum VoucherBrandEnum {
  Dert = 'dertouristik', // CZ
  Kartago = 'kartago' // SK
}

export enum CurrencyEnum {
  CZK = 'CZK',
  EUR = 'EUR',
  HUF = 'HUF',
  USD = 'USD'
}

export enum VoucherSkinEnum {
  Default = 'default',
  Beach = 'beach',
  Christmas = 'christmas_v2',
  Valentine = 'valentine_v2',
  Ski = 'ski'
}
